// Flat LMS entry fee in rand, charged for every round, rollover or not.
// Frontend default only: the amount actually charged is the round's
// lms_rounds.entry_fee (DB column default 100), returned by
// get_lms_entry_fee() (migration 022). Change both together.
export const LMS_ENTRY_FEE = 100
